import React, { useEffect, useRef, useState } from 'react';
import { useParser, parserStore } from '../TranslationTool/useParser';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { isTib, isWylie, queryID } from '../common/utils';
import { Button, Modal } from 'react-bootstrap';
import {
    BsBook,
    FaExternalLinkAlt,
    FiExternalLink,
    HiOutlineXCircle,
} from 'react-icons/all';
import './TermsInfo.scss';
import { useKmap } from '../../hooks/useKmap';
import { getAllDefs } from './TermsInfo';
import TermsDetails from './TermsDetails';
import { Rnd } from 'react-rnd';
import { HtmlCustom } from '../common/MandalaMarkup';
import TermNames from './TermNames';

export function TermsParser({ selectMe }) {
    const location = useLocation();
    // const pathnameRef = useRef(location.pathname);
    const history = useHistory();
    const setStatus = parserStore((state) => state.setStatus);

    const [passage, setPassage] = useState('');
    const [elclass, setElclass] = useState(' font-100');

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    const handleChange = (e) => {
        const value = e.target.value;
        if (isTib(value)) {
            setElclass(' bo');
        } else {
            setElclass(' font-100');
        }
    };

    const returnToPage = (e) => {
        const origUrl = window.localStorage.getItem('originPath');
        history.push(origUrl);
    };

    const {
        isLoading: isParserLoading,
        data: parsedPhrase,
        isError: isParsingError,
        error: parseError,
    } = useParser(passage);

    let wordsout = [];

    function decodeHtmlEntities(str) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = str;
        return textarea.value;
    }

    useEffect(() => {
        window.revertPassage = (el) => {
            const parent = el.parentNode;
            const phrase = parent.dataset.originalPhrase;
            parent.replaceWith(phrase);
            // console.log('revert', el, el.parentNode.dataset);
        };
    }, []);

    useEffect(() => {
        /* original condition for else chunk below
         (
            passage.length > 0 &&
            parsedPhrase?.tokens &&
            parsedPhrase.tokens.length > 0
        )
         */
        if (
            passage.length === 0 ||
            !parsedPhrase?.tokens ||
            parsedPhrase?.tokens.length === 0
        ) {
            // Do nothing
        } else if (parsedPhrase.tokens[0].startsWith('&#91')) {
            // If it starts with &#91, it's an error
            setStatus('invalid');
            setTimeout(() => {
                setPassage('');
                setStatus('valid');
            }, 2000);
        } else {
            // console.log('parsed phrase', parsedPhrase);
            for (let i = 0; i < parsedPhrase.tokens.length; i += 2) {
                // 2nd include is the entities for "#ERROR"
                let termid = parsedPhrase.tokens[i + 1];

                if (termid.includes('.')) {
                    termid = termid.split('.')[0];
                }
                /*
                if (wordsdone.includes(parsedPhrase.tokens[i])) {
                    continue;
                }*/
                if (!Number.isInteger(Number(termid))) {
                    // for "[Not Found]" etc.
                    wordsout.push(
                        '<span class="bo unparsed text-danger" title="Unrecognized term or phrase">' +
                            parsedPhrase.tokens[i] +
                            '་</span>'
                    );
                    continue;
                }
                if (parsedPhrase.tokens[i] === '/') {
                    parsedPhrase.tokens[i] = '<span class="bo parse">།</span>';
                } else {
                    // console.log(parsedPhrase.tokens[i]);
                    const rowclass = (i / 2) % 2 === 0 ? 'even' : 'odd';
                    wordsout.push(
                        '<span data-kid="' +
                            termid +
                            '" class="bo parsed ' +
                            rowclass +
                            '"' +
                            '>' +
                            parsedPhrase.tokens[i] +
                            '་</span>'
                    );
                }
            }

            const range = window.getSelection().getRangeAt(0);
            range.deleteContents();
            let prefpunct = passage.match(/^[\s\u0F0B-\u0F0E]+/);
            prefpunct = prefpunct ? prefpunct[0] : '';
            let muadd =
                '<span class="parsed-phrase" data-original-phrase="' +
                passage +
                '">' +
                prefpunct;
            wordsout.forEach((word) => {
                muadd += word;
            });
            // Icon is SVG for react-icon: <HiOutlineXCircle />
            muadd +=
                '<span class="close-button" ' +
                'onClick="revertPassage(this)" title="Remove parsing"><svg stroke="currentColor" fill="none" ' +
                'stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" ' +
                'xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" ' +
                'stroke-linejoin="round" stroke-width="2" ' +
                'd="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></span></span>';
            range.insertNode(range.createContextualFragment(muadd));

            document.querySelectorAll('.parsed').forEach((el) => {
                el.addEventListener('click', function () {
                    // console.log('el text', el.innerHTML);
                    window.dispatchEvent(
                        new CustomEvent('wpTriggerReact', {
                            detail: {
                                currel: el,
                            },
                        })
                    );
                });
            });
            setPassage('');
            window.getSelection().removeAllRanges();
        }
    }, [passage, parsedPhrase]);

    const origUrl = window.localStorage.getItem('originPath');
    return (
        <>
            <div className="terms parser d-none">
                <div className="container mt-2 m-0">
                    <form onSubmit={handleSubmit} className="pt-1">
                        <div className="form-group">
                            <label htmlFor="messageInput">
                                Enter Tibetan passage to parse <HelpPopup />
                            </label>
                            <textarea
                                id="tibetanPassage"
                                className={'form-control' + elclass}
                                rows="4"
                                onChange={handleChange}
                                placeholder="Type your passage please..."
                            ></textarea>
                        </div>
                        <div className="form-group d-flex justify-content-between w-100">
                            <button
                                type="submit"
                                className="btn btn-primary mt-3"
                                onClick={(e) =>
                                    setPassage(
                                        document.getElementById(
                                            'tibetanPassage'
                                        ).value
                                    )
                                }
                                title="Parse the phrase in the text box"
                                id="term-parser-submit"
                            >
                                Parse
                            </button>
                            {origUrl !== location.pathname && (
                                <div className="d-inline-block align-right">
                                    <button
                                        type="submit"
                                        className="btn btn-primary mt-3"
                                        onClick={(e) => returnToPage()}
                                        title="Returns to original page"
                                    >
                                        Back
                                    </button>
                                </div>
                            )}
                        </div>
                    </form>
                    {wordsout?.length > 0 && (
                        <div className="mt-3">
                            <ul>{wordsout}</ul>
                        </div>
                    )}
                </div>
            </div>
            <TermsParserDefinitionWindow />
        </>
    );
}

function HelpPopup() {
    const [show, setShow] = useState(false);

    return (
        <>
            <Button
                variant="link"
                title="Click for help"
                onClick={() => setShow(true)}
                className="font-85 ml-5"
            >
                Help
            </Button>

            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Terms Parser</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>
                        The parser will parse a Tibetan passage into individual
                        words or phrases. It will list the words in the area
                        below the textbox, with each word linked to its entry in
                        the dictionary.{' '}
                    </p>
                    <p>
                        In addition, one can highlight a Tibetan passage on the
                        page and press option (Mac) or alt (Windows) while
                        clicking on the selection to parse that highlighted
                        passage.
                    </p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShow(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export function TermsParserButton() {
    const status = parserStore((state) => state.status);
    const [selectionText, setSelectionText] = useState('');
    const [selectionRange, setSelectionRange] = useState(null);
    const [buttonPos, setButtonPos] = useState(null);
    const [showBook, setShowBook] = useState(true);

    const lookupPassage = (e) => {
        const mss = 500;
        setTimeout(function () {
            let el = document.getElementById('tibetanPassage');
            if (el) {
                el = document.getElementById('tibetanPassage');
                el.value = selectionText;
            }
            window.localStorage.setItem('originPath', window.location.pathname);
            document.getElementById('term-parser-submit').click();
        }, mss);
        // restoreSelection();
    };
    /*
    const restoreSelection = () => {
        if (!selectionRange) return;

        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(selectionRange);
    };
 */

    useEffect(() => {
        if (status === 'invalid') {
            setShowBook(false);
            setTimeout(() => {
                setSelectionText('');
                setButtonPos(null);
            }, 2000);
        } else {
            setShowBook(true);
        }
    }, [status]);

    useEffect(() => {
        const handleSelection = () => {
            const selection = window.getSelection();
            const text = selection?.toString();
            if (!text || text.trim().length === 0) {
                setSelectionText('');
                setButtonPos(null);
                return;
            }
            const range = selection.getRangeAt(0);
            setSelectionRange(range.cloneRange());
            const rect = range.getBoundingClientRect();
            setSelectionText(text);
            let mytop = rect.top + window.scrollY - 100;
            setButtonPos({
                top: mytop,
                left: rect.left + window.scrollX + rect.width / 2 - 30,
            });
        };

        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                setButtonPos(null);
            }
        };

        document.addEventListener('mouseup', handleSelection);
        document.addEventListener('touchend', handleSelection);
        document.addEventListener('selectionchange', handleSelection);
        document.addEventListener('keyup', handleEscape);

        return () => {
            document.removeEventListener('mouseup', handleSelection);
            document.removeEventListener('touchend', handleSelection);
            document.removeEventListener('selectionchange', handleSelection);
            document.removeEventListener('keyup', handleEscape);
        };
    }, []);

    const mytop = buttonPos?.top - 30 || '-100px';
    const myleft = buttonPos?.left || '-1000px';

    return (
        <button
            style={{
                position: 'absolute',
                top: mytop,
                left: myleft,
                zIndex: 1000,
            }}
            title="Parse the highlighted passage"
            onClick={lookupPassage}
        >
            {showBook ? (
                <BsBook />
            ) : (
                <p className="text-danger">
                    Invalid
                    <br />
                    Unicode Tibetan!
                </p>
            )}
        </button>
    );
}

function TermsParserDefinitionWindow() {
    const [termId, setTermId] = useState(-1);
    const [term, setTerm] = useState('');

    const qid = queryID('terms', termId);
    //const history = useContext(HistoryContext);
    const {
        isLoading: isKmapLoading,
        data: kmapData,
        isError: isKmapError,
        error: kmapError,
    } = useKmap(qid, 'info');

    const {
        isLoading: isAssetLoading,
        data: assetData,
        isError: isAssetError,
        error: assetError,
    } = useKmap(qid, 'asset');

    const submitMe = (e) => {
        e.preventDefault();
        const myel = document.getElementById('termval').dataset;
    };

    useEffect(() => {
        function handleEvent(e) {
            const kid = e.detail.currel.dataset.kid;
            const term = e.detail.currel.innerHTML;
            setTermId(kid);
            setTerm(term);
        }

        function handleEscape(e) {
            if (e.key === 'Escape') {
                setTermId(-1);
            }
        }

        window.addEventListener('wpTriggerReact', handleEvent);
        window.addEventListener('keyup', handleEscape);

        return () => {
            window.removeEventListener('wpTriggerReact', handleEvent);
            window.removeEventListener('keyup', handleEscape);
        };
    }, []);

    const [definitions, otherDefinitions] = getAllDefs(kmapData);

    if (termId === -1 || kmapData === undefined) return <></>;

    return (
        <Rnd
            default={{
                x: 200,
                y: 100,
                width: 800,
                height: 500,
            }}
            bounds="body"
            dragHandleClassName="drag-handle"
        >
            <div
                id="term-parse-definitions"
                style={{
                    width: '100%',
                    height: '100%',
                    padding: '6px',
                    pointerEvents: 'auto',
                    zIndex: 10000,
                }}
            >
                <div className="wrapper">
                    <div className="close-button">
                        <span
                            className="link"
                            onClick={(e) => {
                                e.preventDefault();
                                setTermId(-1);
                            }}
                        >
                            x
                        </span>
                    </div>
                    <div className="drag-handle"></div>
                    <h2>
                        Results for <span className="bo">{term}</span>{' '}
                        <span className="font-weight-normal font-80">
                            ({termId}){' '}
                            <Link
                                to={`/terms/${termId}`}
                                target="_blank"
                                title="Open term in new tab"
                            >
                                <FiExternalLink />
                            </Link>
                        </span>
                    </h2>
                    {termId > -1 && kmapData && (
                        <div className="term-content">
                            <TermsHead
                                kmapData={kmapData}
                                assetData={assetData}
                            />
                            <TermsDetails
                                kmapData={kmapData}
                                definitions={definitions}
                                otherDefinitions={otherDefinitions}
                            />
                        </div>
                    )}

                    <form id="parser-term-form" className="d-none" action="">
                        <input id="termval" type="text" />
                        <button id="subbutt" onClick={submitMe}>
                            Load
                        </button>
                    </form>
                </div>
            </div>
        </Rnd>
    );
}

function TermsHead({ kmapData, assetData }) {
    const caption_eng =
        kmapData?.caption_eng?.length > 0 ? (
            <>
                <h4>Caption</h4>
                <HtmlCustom markup={kmapData.caption_eng[0]} />
            </>
        ) : null;

    const summary_eng =
        kmapData?.summary_eng?.length > 0 ? (
            <>
                <h4>Summary</h4>
                <HtmlCustom markup={kmapData.summary_eng[0]} />
            </>
        ) : null;

    return (
        <>
            <TermNames kmap={kmapData} kmAsset={assetData} />
            {(caption_eng || summary_eng) && (
                <div>
                    {caption_eng}
                    {summary_eng}
                </div>
            )}
        </>
    );
}
